import { useMemo, useState } from 'react';
import { createContexts } from '@/js/libs/create-contexts/index.ts';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { countColumns } from './countColumns.js';
const DEFAULT_COLUMN_META = { columns: '', hasDnd: false, hasCheckbox: false, hasAction: false, fluid: false };
export const { useTableContext } = createContexts({
    Table({ inner, compact }) {
        const [meta, setMeta] = useState(DEFAULT_COLUMN_META);
        const columnCount = useMemo(() => (meta.columns ? countColumns(meta.columns) : 0), [meta.columns]);
        const registerColumns = useCallbackRef((next) => setMeta((prev) => prev.columns === next.columns &&
            prev.hasDnd === next.hasDnd &&
            prev.hasCheckbox === next.hasCheckbox &&
            prev.hasAction === next.hasAction &&
            prev.fluid === next.fluid
            ? prev
            : next));
        return {
            inner,
            compact: !!compact,
            columns: meta.columns,
            columnCount,
            registerColumns,
            hasDnd: meta.hasDnd,
            hasCheckbox: meta.hasCheckbox,
            hasAction: meta.hasAction,
            fluid: meta.fluid,
        };
    },
});
